export class SortDirection {
    public static readonly Ascending: string = '0';
    public static readonly Descending: string = '1';
  }
